import React, { useEffect, useState, useContext } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Switch from '@mui/material/Switch';
import img from '../../../assets/images/user.png'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
// import UserOrderTable from '../../../components/table/Use
import ConfirmBox from '../../../components/ConfirmBox';
import commentorPhoto from '../../../assets/images/user.png'

import outlet from '../../../assets/images/outlet-2.png'

import { AuthContext } from '../../../context/AuthContext'


const Single = ({user}) => {

  const {outletId} = useParams()

  const [ outletData, setOutletData ] = useState([])

  const [ userData, setUserData ] = useState([])

  const [ review, setReview] = useState([])

  const [accountUser, setAccountUser] = useState(false) 

  const [checked, setChecked] = React.useState(true);

  const [photos, setPhotos] = useState([])
 
  const [ openModal, setOpenModal ] = useState(false)

  const [payment, setPayment] = useState([])

  const closeModal = () => setOpenModal(false)

  const [openStatus, setOpenStatus] = useState(false)


  const { currentUser } = useContext(AuthContext)
        
  const userIds = currentUser.uid;
      
  const [adminRole, setAdminRole] = useState("")

  const [verifiedStatus, setVerifiedStatus] = useState(false)


      
  const getAdminRole = async() => {
    
    const docRef = doc(db, "admins", userIds);

    const docSnap = await getDoc(docRef);

    
    if (docSnap.exists()) {

      setAdminRole(docSnap.data().role)

    } else {

      console.log("No such document!");
    }
  }


  useEffect(()=>  {

    getAdminRole()

  }, [])
    
  



  const handleChange = (event) => {
    setChecked(event.target.checked);
  };



  const getOutlet = async() => {

      onSnapshot(doc(db, "subscribers", outletId), (docSnap) => {

        if (docSnap.exists()) {

          setOutletData(docSnap.data())
          setAccountUser(true)
          setPhotos(docSnap.data().files)
          // console.log(outletData)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }

        // console.log("Current data: ", doc.data());

        // setUserData(doc.data())

      });

  


      // const docRef = doc(db, "subscribers", outletId);

      // const docSnap = await getDoc(docRef);

    
      
      // if (docSnap.exists()) {

      //   setOutletData(docSnap.data())
      //   setAccountUser(true)
      //   setPhotos(docSnap.data().files)
      //   // console.log(outletData)
      // } else {
      //   // doc.data() will be undefined in this case
      //   console.log("No such document!");
      // }
  }

  useEffect(()=>{

    getOutlet()

  }, [])


   useEffect(() => {
    
    //LISTEN REAL TIME

    const reviewQuery = async() => {

      const reviewRef = (collection(db, "reviews"));

      const q = query(reviewRef, where("subId", "==", outletId));

      const querySnapshot = await getDocs(q);
        let list = []
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        list.push(doc.data())
        // console.log(doc.id, " => ", doc.data());
        console.log(list)

        setReview(list)
        // console.log(orderData)
      });

    }
    
    reviewQuery()   

  },[])





const handleModal = (photo) => {

  setOpenModal(true) 
  setPhotos(photo)

}


  const options = {  maximumFractionDigits: 2 }


  const Modal = ({open, close, photo}) => {
     
    if(!open) return null

    return(
     <div style={{
      backgroundColor: 'black',
      widows:'100%',
      height:'100%',
     }}>
       <div style={{

        maxWidth: 600,
        backgroundColor: 'white',
      }}>
       
         <div className="modalRight">
           <p className="closeBtn" onClick={close}>X</p>
           <div></div>

 
         </div>
       </div>
     </div>
    )
}


     const handleStatus = async() => {
    
        
        const outletRef = doc(db, "subscribers", outletId);
    
        await updateDoc(outletRef, {
    
        status: outletData.status === "active" ? 'inactive' : 'active', 
    
     })
    
      setOpenStatus(false)
    
      }


      const handleVerified = async() => {

         
        const outletRef = doc(db, "subscribers", outletId);
    
        await updateDoc(outletRef, {
    
          IsVerified: outletData.IsVerified === true ? false : true, 
    
        })
    

      }
 

  return (
    <div className='single'>
      <Modal open={openModal} close={closeModal} />
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Information</h2>

            {
              adminRole === "adminAccess"

              ?

                <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>

                <a onClick={(event)=> {event.preventDefault(); handleVerified()}}  style={{ border: '1px solid #2196F3', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:outletData.IsVerified ? "#2196F3" : "red", cursor:'pointer'}}>
                    <span style={{color:'#ffffff', fontWeight:'bold'}}>{outletData.IsVerified  ? "Verified" : "Unverified"}</span>
                </a>

                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:outletData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{outletData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/outlets/edit/${outletId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            adminRole === "subadminAccess"

            ?

              <div style={{display:'flex', flexDirection:'row', gap:10, justifyContent:'center', alignItems:'center', marginRight:100 }}>

                
                <a onClick={(event)=> {event.preventDefault(); handleVerified()}}  style={{ border: '1px solid #2196F3', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:outletData.IsVerified ? "#2196F3" : "red", cursor:'pointer'}}>
                    <span style={{color:'#ffffff', fontWeight:'bold'}}>{outletData.IsVerified  ? "Verified" : "Unverified"}</span>
                </a>

                <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:outletData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>{outletData.status === "active" ? "Active" : "Inactive"}</span>
                </a>

                 <Link to={`/outlets/edit/${outletId}`} style={{ border: '1px solid blue', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"blue", cursor:'pointer'}}>
                    <span style={{color:'white', fontWeight:'bold'}}>Edit</span>
                </Link>

      

            </div>

            :

            ""



            }

          
         

            </div>
            <div className='item'>
              <div style={{width:'200px', height:'200px', alignItems:'center', justifyContent:'center'}}>

              <img
                src = {outlet }
                alt="avatar"
                style={{width:'100px', height:'100px'}}
                   
              /> 

              </div>
          
              
                <div className="details">
                  {/* <h3 className='itemTitle'>Outlet Information</h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Subscriber ID:</span>
                    <span className='itemValue'>{outletData.subscriberID}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Name:</span>
                    <span className='itemValue'>{outletData.outletname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet:</span>
                    <span className='itemValue'>{outletData.outlet}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Region:</span>
                    <span className='itemValue'>{outletData.region}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Area:</span>
                    <span className='itemValue'>{outletData.area}</span>
                  </div>
                </div>


                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{outletData.address_short}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Full Address:</span>
                    <span className='itemValue'>{outletData.address}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Telephone:</span>
                    <span className='itemValue'>{outletData.telephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Whatsapp Number:</span>
                    <span className='itemValue'>{outletData.whatsapp}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{outletData.date}</span>
                  </div>
                 
                </div>



                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Subscription Plan:</span>
                    <span className='itemValue'>{outletData.subscriberPlan}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Subscription Amount:</span>
                    <span className='itemValue'>N{Intl.NumberFormat("en-US",options).format(outletData.amount)}.00</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Payment Reference:</span>
                    {/* <span className='itemValue'>{outletData.payment.transactionRef.reference}</span> */}
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Open Hour:</span>
                    <span className='itemValue'>{outletData.open}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Creation Date:</span>
                    <span className='itemValue'>{outletData.date}</span>
                  </div>
                 
                </div>

              

            </div>
          </div>
          
        </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Subscriber(Owner) Details</h2>
            <div className='item'>
            <img
                src = {outletData.userImage ? outletData.userImage : img}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%', marginTop:20}}
                   
            /> 
              
                <div className="details">
                  {/* <h3 className='itemTitle'>Outlet Information</h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Customer ID:</span>
                    <span className='itemValue'>{outletData.userCustomerId}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Firstname:</span>
                    <span className='itemValue'>{outletData.userFirstname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Lastname:</span>
                    <span className='itemValue'>{outletData.userLastname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{outletData.userGender}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Age Range:</span>
                    <span className='itemValue'>
                      {
                      outletData.ageRange === "firstagerange"
                      ?
                      "18 to 29"
                      :
                      outletData.ageRange === "secondagerange"
                      ?
                      "30 to 39"
                      :
                      outletData.ageRange === "thirdagerange"
                      ?
                      "40 to 59"
                      :
                      "60 and Above"
                   
                      }
                    </span>
                  </div>
                </div>


                <div className="details">
                  {/* <h3 className='itemTitle'></h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='itemValue'>{outletData.userTelephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{outletData.userEmail}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Outlet Telephone:</span>
                    <span className='itemValue'>{outletData.telephone}</span>
                  </div>
                  
                 
                </div>


            </div>
          </div>
         
        </div>
        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Photos</h2>
            <div style={{display:'flex', flexDirection:'row', gap:30, flexWrap:'wrap'}}>

            {/* <img
                src = {outletData.files.map(item => item)}
                alt="avatar"
                style={{width:'200px', height:'200px'}}
                   
            />  */}

          
             {
              photos.map(item =>(
                <div key={item}  style={{position:'relative'}}>
                  {/* <button onClick={() => handleModal(item)} style={{position:'relative'}}> */}

                  {/* <button style={{position:'relative'}}> */}

                  <div style={{display:'flex', position:'absolute', top:10, right:10, width:30, height:30, justifyContent:'center', borderRadius:'50%', backgroundColor:'#666'}}><h4 style={{alignSelf:'center', color:'#999'}}>X</h4></div>

                    <img
                    
                      key={item}
                      src = {item}
                      alt="avatar"
                      style={{width:'200px', height:'200px', borderRadius:10}}
                    
                    /> 

                  {/* </button> */}
                  
                </div>
              ))
             } 
          
              

            </div>
          </div>
          {/* <div>
            <Chart 
              aspect={3/1}
              title = "Customer purchase last 6 months"
            />
          </div> */}
        </div>


        <div className="top">
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Reviews</h2>

            {
              review.map(item => (

                <div style={{display:'flex', flexDirection:'column', gap:10, padding:20}}>
                  <div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:20}}>

                    <img
                      src = {commentorPhoto ? commentorPhoto : img}
                      alt="avatar"
                      style={{width:'60px', height:'60px', borderRadius:'50%'}}
                        
                    /> 
                    <div style={{display:'flex', flexDirection:'column', gap:10}}>
                      <p style={{ color:'#666', fontweight:300, fontsize:14}}>{item.commentor}</p>
                      <p style={{fontweight:200, color:'#ccc', fontsize:12}}>{item.today}</p>
                    </div>

                  </div>
            
                  <p style={{color:'#999'}}>{item.review}</p>
                <div>

           </div>


            </div>

              ))
            }


            
          </div>
         
        </div>

        

        <div className="bottom">
        {/* <div className='listTitle'>Customer Transactions History</div> */}
          {/* <UserOrderTable
                outletId = {outletId}
          /> */}
        </div>

        <ConfirmStatusBox
          openStatus={openStatus}
          closeDialog={() => setOpenStatus(false)}
          statusFunction={handleStatus }
        />



      </div>
    </div>
  )
}

export default Single